import $ from 'jquery';

var pdf = $('<div/>'); // object used for events that can be used in the hooks

export default {
    debug: true,     // write debug informations to console.log
    hash: null,      // current location hash (#document,page)
    token: '',       // unique token of this session
    files: [],       // all available files
    fileidx: 0,      // the index of current file
    file: { name: '', hash: ''}, // the current file (same as file[fileidx])
    base: '',        // base URL
    page: 0,         // current page number
    pageMax: 0,      // number of pages
    feature: {},     // available features
    hsm: [],         // list of supported HSMs
    info: null,      // main informations
    sigInfo: null,   // informations about signatures
    panel: {},       // side panels
    map: null,       // Leaflet object
    pdf: pdf         // object used for events that can be used in the hooks
};
